import { render, staticRenderFns } from "./ShortcutBox.vue?vue&type=template&id=ce5faf2e"
import script from "./ShortcutBox.vue?vue&type=script&lang=js"
export * from "./ShortcutBox.vue?vue&type=script&lang=js"
import style0 from "./ShortcutBox.vue?vue&type=style&index=0&id=ce5faf2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports